import { Component, h, Host, Prop, State, Watch } from "@stencil/core";
import { MessageType } from "@trumpf/ux.ui";
import {
    SpinnerMessageStatusEnum,
    SpinnerMessageTransitionStatusType,
} from "./spinner-message-status";

@Component({
    tag: "ux-iws-spinner-message",
    styleUrl: "spinner-message.scss",
    shadow: false,
})
export class SpinnerMessage {
    private baseClass = "ux-iws-spinner-message";
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    private transitionTimeout: any | null = null;

    /** Boolean to indicate if or not the spinner-overlay is currently opened */
    @Prop() opened: boolean = false;
    /** Boolean to indicate if or not the spinner-overlay is currently opened */
    @Prop() message: string = "";

    /** The spinner-overlay transition status */
    @State() status: SpinnerMessageTransitionStatusType =
        SpinnerMessageStatusEnum.CLOSED;

    @Watch("opened")
    setOverlayStatus() {
        if (this.transitionTimeout !== null) {
            clearTimeout(this.transitionTimeout);
        }
        if (this.opened) {
            if (this.status === SpinnerMessageStatusEnum.OPENED) {
                return;
            }
            this.status = SpinnerMessageStatusEnum.OPENING;
            this.transitionTimeout = setTimeout(() => {
                this.status = SpinnerMessageStatusEnum.OPENED;
            }, 100);
        } else {
            if (this.status === SpinnerMessageStatusEnum.CLOSED) {
                return;
            }
            this.status = SpinnerMessageStatusEnum.CLOSING;
            this.transitionTimeout = setTimeout(() => {
                this.status = SpinnerMessageStatusEnum.CLOSED;
            }, 350);
        }
    }

    componentWillLoad() {
        this.setOverlayStatus();
    }

    render() {
        const renderSpinner = this.status !== SpinnerMessageStatusEnum.CLOSED;
        return (
            <Host
                class={{
                    [this.baseClass]: true,
                    [`${this.baseClass}--${this.status}`]: true,
                }}
            >
                <div class={`${this.baseClass}__backdrop`}>
                    <div class={`${this.baseClass}__container`}>
                        {renderSpinner && (
                            <ux-loader variant="spinner"></ux-loader>
                        )}
                        {this.message !== "" && (
                            <div class={`${this.baseClass}__message-container`}>
                                <ux-message-box
                                    type={"info" as MessageType}
                                    no-close-button
                                >
                                    <p>{this.message}</p>
                                </ux-message-box>
                            </div>
                        )}
                    </div>
                </div>
            </Host>
        );
    }
}
